import { render, staticRenderFns } from "./articleDoctor.vue?vue&type=template&id=a2c436f4&scoped=true&"
import script from "./articleDoctor.vue?vue&type=script&lang=js&"
export * from "./articleDoctor.vue?vue&type=script&lang=js&"
import style0 from "./articleDoctor.vue?vue&type=style&index=0&id=a2c436f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c436f4",
  null
  
)

export default component.exports